import { useDisplayWebContentSelector } from './useDisplayWebContentSelector';

export const useTemplateSelector = ({ messageId }: { messageId: string }) => {
  const message = useDisplayWebContentSelector({ messageId });
  return message?.template;
};
